

// 国内铁路
export const RailwayFreightZh = {
  // 中文
  Railway: {
    Placeholder: '请输入',
    EnterDate: '输入日期',
    Download: '下载',
    NoData: '暂无数据',
    SubscriptionCenter: '订阅中心',
    NumberOfPackage: '件数',
    StartDate: '开始日期',
    EndDate: '结束日期',
    YouCan: '您可以',
    NotSupportedPreview: '当前文件不支持预览',
    SwitchToCard: '切换为卡片模式',
    SwitchToList: '切换为列表模式',
    DataStatistics: '数据统计',
    OrderInquiry: '订单查询',
    CurrentMonth: '当月度',
    CurrentQuarter: '当季度',
    CurrentYear: '当年度',
    Teu: '标箱数',
    ContainerVolume: '集装箱量',
    YearlyStatistics: '当年统计',
    QuarterlyStatistics: '当季统计',
    MonthlyStatistics: '当月统计',
    CustomerConsignmentNo: '客户委托编号',
    OrderNumber: '订单号',
    ContainerNo: '箱号',
    OrderPlacementPeriod: '下单区间',
    OrderPlacementTime: '下单日期',
    Search: '查询',
    Reset: '重置',
    Export: '导出',
    DetailsView: '明细查看',
    TransportationTerms: '运输条款',
    LoadingAddress: '装货地址',
    UnloadingAddress: '卸货地址',
    DeliveryAddress: '送货地址',
    Operation: '操作',
    Number: '序号',
    Arrival: '到站',
    Departure: '发站',
    ProductName: '品名',
    TotalWeight: '总重量 (KG)',
    ContainerTypeQuantity: '箱型箱量',
    PickUpTime: '提货时间',
    EstimatedShippingTime: '发运时间',
    ActualShippingTime: '实际发运时间',
    EstimatedArrivalTime: '到站时间',
    ActualArrivalTime: '实际到站时间',
    EstimatedDeliveryTime: '送货时间',
    DeliveryTime: '送货时间',
    NoReceipt: '暂无回单',
    ViewReceipts: '查看回单',
    Declaration: '免责声明：尊敬的客户，本页面显示的业务相关数据信息，因存在业务量动态变化以及信息更新滞后等情况，仅供参考，无法律约束力。最终信息，以双方书面确认为准，感谢理解与配合。'
  }
}

export const RailwayFreightEn = {
  // 英文
  Railway: {
    Placeholder: 'Please Enter',
    EnterDate: 'Enter Date',
    Download: 'Download',
    NoData: 'No data available',
    SubscriptionCenter: 'Subscription',
    NumberOfPackage: 'Number of Package',
    StartDate: 'Start date',
    EndDate: 'End date',
    YouCan: 'You can',
    NotSupportedPreview: 'The current file does not support preview',
    SwitchToCard: 'Switch to card mode',
    SwitchToList: 'Switch to list mode',
    DataStatistics: 'Dashboard',
    OrderInquiry: 'Tracking',
    CurrentMonth: 'Current Month',
    CurrentQuarter: 'Current Quarter',
    CurrentYear: 'Current Year',
    Teu: 'TEU',
    ContainerVolume: 'Container Volume',
    YearlyStatistics: 'Yearly statistics',
    QuarterlyStatistics: 'Quarterly statistics',
    MonthlyStatistics: 'Monthly statistics',
    CustomerConsignmentNo: 'Your Ref No.',
    OrderNumber: 'MW No.',
    ContainerNo: 'Container No.',
    OrderPlacementPeriod: 'Booking date',
    OrderPlacementTime: 'Booking Date',
    Search: 'Search',
    Reset: 'Reset',
    Export: 'Export',
    DetailsView: 'View Details',
    TransportationTerms: 'Transportation terms',
    LoadingAddress: 'Loading address',
    UnloadingAddress: 'Unloading address',
    DeliveryAddress: 'Delivery address',
    Operation: 'Process',
    Number: 'Number',
    Arrival: 'Arrival',
    Departure: 'Departure',
    ProductName: 'Description of Goods',
    TotalWeight: 'Total Weight (KG)',
    ContainerTypeQuantity: 'Container Type/Quantity',
    PickUpTime: 'Pick up time',
    EstimatedShippingTime: 'Shipping time',
    ActualShippingTime: 'Shipping time',
    EstimatedArrivalTime: 'Arrival time',
    ActualArrivalTime: 'Arrival time',
    EstimatedDeliveryTime: 'Delivery time',
    DeliveryTime: 'Delivery time',
    NoReceipt: 'No POD',
    ViewReceipts: 'View POD',
    Declaration: 'Disclaimer:  The relevant information displayed on this page is for your reference only. The final information is subject to written confirmation by both parties.'
  }
}
